export default "__VITE_ASSET__DdDZt47s__"